import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=ebc52aaa&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=ebc52aaa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebc52aaa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ebc52aaa')) {
      api.createRecord('ebc52aaa', component.options)
    } else {
      api.reload('ebc52aaa', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=ebc52aaa&scoped=true&", function () {
      api.rerender('ebc52aaa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2We82f2iGvkGZ/JS/comp/PopupDialog.vue"
export default component.exports